import { createApi } from '@reduxjs/toolkit/query/react'
import { ASSIGN_THERAPIST, CLINICIAN_HISTORY_LIST, LIST_CLIENT_CASELOADS, REMOVE_THERAPIST_ASSIGNMENT, UPDATE_THERAPIST_SERVICE_STATUS } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { schoolClientsApi } from "./clients/school.client";

export const clientCaseLoadsApi = createApi({
  reducerPath: 'clientCaseLoadsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/client/caseload",
  }),
  tagTypes: ["SchoolClientDetails"],
  endpoints: (builder) => ({
    assignTherapist: builder.mutation({
      query: ({ caseload_id, therapist_id, discipline_id }) => ({
        method: "PATCH",
        url: `${ASSIGN_THERAPIST}/${caseload_id}/${therapist_id}/${discipline_id}`
      }),
      invalidatesTags: ["SchoolClientDetails"]
    }),
    removeTherapistAssignment: builder.mutation({
      query: (assignmentId) => ({
        method: "DELETE",
        url: `${REMOVE_THERAPIST_ASSIGNMENT}/${assignmentId}`
      }),
      invalidatesTags: ["SchoolClientDetails"]
    }),
    getClientCaseloadsList: builder.query({
      query: ({ id, search = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "DESC" } }) => ({
        method: "PATCH",
        url: `${LIST_CLIENT_CASELOADS}/${id}`,
        data: { search, status, page, limit, sort }
      }),

      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["clientCaseloadsList"]
    }),
    updateTherapistServiceStatus: builder.mutation({
      query: ({ payload, id }) => ({
        method: "PATCH",
        url: `${UPDATE_THERAPIST_SERVICE_STATUS}/${id}`,
        data: payload
      }),
    }),
    getCliniciansHistory: builder.query({
      query: ({ clientId }) => ({
        method: "PATCH",
        url: `${CLINICIAN_HISTORY_LIST}/${clientId}`,
      }),

      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["cliniciansHistory"]
    }),
  }),
})

export const {
  useAssignTherapistMutation,
  useRemoveTherapistAssignmentMutation,
  useGetClientCaseloadsListQuery,
  useUpdateTherapistServiceStatusMutation,
  useGetCliniciansHistoryQuery
} = clientCaseLoadsApi;